<script lang="ts">
import type { StudyChargeDistributionStats } from '$lib/components/study/slide-layout-types'

/** Four-up P25 / median / P75 / mean tiles under the IQR strip (s6c-style). */
interface Props {
  stats: StudyChargeDistributionStats
  formatSpend: (n: number) => string
  gridClass?: string
  gridStyle?: string
}

let {
  stats,
  formatSpend,
  gridClass = '',
  gridStyle = 'display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:.5rem;margin-top:1rem;',
}: Props = $props()
</script>

<div class="study-charge-quartile-stat-grid {gridClass}" style={gridStyle}>
  <div class="sb" style="padding:.85rem .5rem;text-align:center;">
    <div style="font-size:.65rem;color:var(--mu);letter-spacing:.08em;text-transform:uppercase;">
      P25
    </div>
    <div style="font-family:'DM Serif Display',serif;font-size:1.2rem;color:var(--g);">
      {formatSpend(stats.p25)}
    </div>
  </div>
  <div class="sb" style="padding:.85rem .5rem;text-align:center;">
    <div style="font-size:.65rem;color:var(--mu);letter-spacing:.08em;text-transform:uppercase;">
      Median
    </div>
    <div style="font-family:'DM Serif Display',serif;font-size:1.2rem;color:var(--t2);">
      {formatSpend(stats.median)}
    </div>
  </div>
  <div
    class="sb"
    style="padding:.85rem .5rem;text-align:center;border-left:2px dashed rgba(255,209,102,.35);"
  >
    <div style="font-size:.65rem;color:var(--mu);letter-spacing:.08em;text-transform:uppercase;">
      Mean
    </div>
    <div style="font-family:'DM Serif Display',serif;font-size:1.2rem;color:#ffd166;">
      {formatSpend(stats.mean)}
    </div>
  </div>
  <div class="sb" style="padding:.85rem .5rem;text-align:center;">
    <div style="font-size:.65rem;color:var(--mu);letter-spacing:.08em;text-transform:uppercase;">
      P75
    </div>
    <div style="font-family:'DM Serif Display',serif;font-size:1.2rem;color:var(--amb);">
      {formatSpend(stats.p75)}
    </div>
  </div>
</div>

<style>
@media (max-width: 640px) {
  .study-charge-quartile-stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
</style>
